import React, { useEffect, useState } from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import Loading from "../Loading";
import api from "../../services/api";

const ProtectedRoute = ({ redirectPath = "/", children }) => {
  const { code } = useParams();
  const [searchParams] = useSearchParams();

  const [loading, setLoading] = useState(true);
  const [allowed, setAllowed] = useState(false);

  useEffect(() => {
    const run = async () => {
      setLoading(true);
      try {
        const response = await api.checkIfRegistrationIsActive(code, searchParams);
        setAllowed(!!response?.status);
      } catch {
        setAllowed(false);
      } finally {
        setLoading(false);
      }
    };

    run();
  }, [code]);

  if (loading) return <Loading />;
  if (!allowed) return <Navigate to={redirectPath} replace />;

  return children;
};

export default ProtectedRoute;